import { Outlet } from 'react-router-dom';
import { Link } from 'react-router-dom';
import bandjerryLogo from '@/images/bandjerry_logo.svg';

export default function AuthLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#111] px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="mb-8 text-center">
          <Link to="/">
            <h1 className="inline-flex items-center gap-2 text-3xl font-bold">
              <img src={bandjerryLogo} alt="BandJerry logo" className="h-[1em] w-auto" />
              <span><span className="text-white">BAND</span><span className="text-primary-600">JERRY</span></span>
            </h1>
          </Link>
        </div>

        {/* Auth form card */}
        <div className="rounded-xl bg-neutral-200 p-6 shadow-sm border border-neutral-300">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
